
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import LandscapingHero from './components/LandscapingHero';
import LandscapingServices from './components/LandscapingServices';
import LandscapingProcess from './components/LandscapingProcess';
import LandscapingGallery from './components/LandscapingGallery';
import LandscapingFAQ from './components/LandscapingFAQ';
import LandscapingQuoteSidebar from './components/LandscapingQuoteSidebar';

const LandscapingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <LandscapingHero />
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                <LandscapingServices />
                <LandscapingProcess />
                <LandscapingGallery />
                <LandscapingFAQ />
              </div>
              <div className="lg:col-span-1">
                <LandscapingQuoteSidebar />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default LandscapingPage;
